import styles from './Contact.module.css'
import Reveal from '../Reveal/Reveal'
import SectionTitle from '../SectionTitle/SectionTitle'
import ContactForm from './ContactForm/ContactForm'
import Map from './Map/Map'
import { AppConstants } from '../../AppConstants'
const Contact = () => {
    return (
        <section id='contact' className={styles.contact}>
            <Reveal>
                <div className="container">
                    <SectionTitle>
                        {AppConstants.NavigationMenus.Contact}<span> {AppConstants.CommonWords.Me}</span>
                    </SectionTitle>
                    <div className={`${styles['contact-form']} `}>
                        <div className={styles.cform}>
                            <ContactForm />
                        </div>
                        <div className={`${styles.content}`}>
                            <Map />
                        </div>
                    </div>
                </div>
            </Reveal>
        </section>
    )
}
export default Contact
